<template>
	<div class="container">
		<h1 class="heading-1 text-align-center mb-100 mb-200-md">New User Reward</h1>
		<section class="grid-md">
			<article class="col-8-md col-offset-2-md position-relative">
				<div class="module">
					<div class="module-header">
						<h2 class="heading-5">Terms and Conditions</h2>
					</div>
					<div class="module-section">
						<p>
							You must agree to the following terms and conditions in order to receive a Share Voucher for
							shares of Fundrise Real Estate Interval Fund, LLC (the “Share Voucher”) that you may redeem
							when opening a “Qualifying New Account” (as defined below).
						</p>
						<p
							>The Share Voucher offer is only valid for selected individuals who are not currently
							invested in Fundrise, open a Qualifying New Account, and fulfill the conditions of the
							reward offer. Individuals must receive an invitation from Fundrise describing this offer to
							take advantage of the Share Voucher reward. The Share Voucher will be provided to you within
							approximately one week after all conditions are satisfied.
						</p>
						<p>
							A Qualifying New Account is (i) an individual Fundrise account that Fundrise has applied
							this Share Voucher reward offer to and invited to participate, and (ii) through which an
							initial investment that meets the reward offer's minimum investment amount is placed within
							14 days. Please note, (i) the Share Voucher is not available to individuals who invest
							through an IRA, and (ii) by signing up as an investor on the Fundrise platform, individuals
							become a client of Fundrise Advisors, LLC. Fundrise is not responsible for incorrect entry
							or other failure on the part of the investor to meet the standards of a Qualifying New
							Account.
						</p>

						<p
							>The Share Voucher offer is not valid with any other share voucher/bonus offers and is
							non-transferrable. The Share Voucher offer is available to U.S. residents only. Fundrise
							Advisors, LLC reserves the right to change the offer terms or terminate this Share Voucher
							offer at any time without notice for any reason and to refuse or recover any Share Voucher
							if Fundrise Advisors, LLC determines that it was obtained under wrongful or fraudulent
							circumstances, that inaccurate or incomplete information was provided in opening the
							Qualifying New Account or connecting the bank account, that any rules or regulations would
							be violated, or that any terms of the Fundrise Client Agreement have been violated. The
							Share Voucher offer is limited to one Share Voucher per Fundrise account, with no more than
							one Fundrise account enrolled per investor. Other restrictions may apply.
						</p>

						<p
							>Consult with your tax advisor about the appropriate tax treatment for this Share Voucher
							offer and any tax implications associated with receipt of the Share Voucher before
							enrolling. Fundrise does not take responsibility for any tax related to this Share Voucher.
						</p>
					</div>
				</div>
			</article>
		</section>
	</div>
</template>
